
import Vue from "vue";
import base64js from "base64-js";
import {EnterOtpStep, OtpType} from "@/constant/login";
import loginService from "@/services/loginService";
import msDataProvider from "@/services/msDataProvider";
import Otp from "@/views/login/partials/Otp.vue";

export default Vue.extend({
  components: {
    Otp
  },
  data() {
    return {
      OtpType,
      showMenu: false,
      data: {},
      error: "",
      otpTypeItems: [] as any,
      otpTypeLabels: {
        [OtpType.EmailOtp]: 'Email OTP',
        [OtpType.SMS]: 'SMS OTP',
        [OtpType.TOTP]: 'TOTP',
        [OtpType.SecurityKey]: 'Security Key'
      },
      step: EnterOtpStep.ENTER_OTP,
      enterOtpStepEnum: EnterOtpStep,
      prepareResponse: loginService.getPrepareLoginResponse(),
      prepareLoading: false,
    };
  },
  methods: {
    async changeOtpType(type: OtpType) {
      this.resendLoading = 0;
      this.expected_mfas = [type];
      await this.prepare({expected_mfas : [type]});
      switch (type) {
        case OtpType.TOTP:
          this.$router.push("/login/totp");
          break;
        case OtpType.SMS:
          this.$router.push("/login/sms_otp");
          break;
        case OtpType.EmailOtp:
          this.$router.push("/login/email_otp");
          break;
        case OtpType.SecurityKey:
          this.$router.push("/login/security_key");
          break;
      }
    },
    async prepare(params: any = {}) {
      this.errorPrepare = "";
      try {
        this.prepareLoading = true;
        const response = await msDataProvider.executeCommand(
            "authenPrepareLogin",
            params
        );

        if (response.error_info.error_code) {
          this.errorPrepare = response.error_info.message;
          return;
        }
        loginService.setPrepareLoginResponse(response);
        this.prepareResponse = response;
        if (!response.type) {
          this.$router.push("/prepare").catch((e) => e);
          return;
        }
      } catch (e) {
        this.errorPrepare = e;
      } finally {
        this.prepareLoading = false;
      }
    },
    bufferEncode(value) {
      return base64js
          .fromByteArray(value)
          .replace(/\+/g, "-")
          .replace(/\//g, "_")
          .replace(/=/g, "");
    },
    bufferDecode(value) {
      return Uint8Array.from(atob(value), (c) => c.charCodeAt(0));
    },
    buffer2string(buf) {
      let str = "";
      if (!(buf.constructor === Uint8Array)) {
        buf = new Uint8Array(buf);
      }
      buf.map((x) => {
        return (str += String.fromCharCode(x));
      });
      return str;
    },
    async onReady(data, onReadyToSubmit, submit) {
      try {
        if (!window.PublicKeyCredential) {
          throw new Error("Current platform not support");
        }

        const response = JSON.parse(data.data);
        const payload = JSON.parse(response.payload);
        payload.publicKey.challenge = this.bufferDecode(
            payload.publicKey.challenge
        );

        if (!response.ready) {
          payload.publicKey.user.id = this.bufferDecode(
              payload.publicKey.user.id
          );
          if (payload.publicKey.excludeCredentials) {
            payload.publicKey.excludeCredentials.forEach((listItem) => {
              listItem.id = this.bufferDecode(listItem.id);
            });
          }
          if (payload.publicKey.rp) {
            payload.publicKey.rp.id = document.domain;
          }
          if (payload.publicKey.rpId) {
            payload.publicKey.rpId = document.domain;
          }

          const credentialRaw = await navigator.credentials.create(payload);
          const credential = credentialRaw as any;

          onReadyToSubmit({
            custom_payload: JSON.stringify({
              id: credential.id,
              rawId: this.bufferEncode(new Uint8Array(credential.rawId)),
              type: credential.type,
              response: {
                attestationObject: this.bufferEncode(
                    new Uint8Array(credential.response.attestationObject)
                ),
                clientDataJSON: this.bufferEncode(
                    new Uint8Array(credential.response.clientDataJSON)
                ),
              },
            }),
          });
          submit();
        } else {
          payload.publicKey.allowCredentials.forEach((listItem) => {
            listItem.id = this.bufferDecode(listItem.id);
          });

          const credentialRaw = await navigator.credentials.get(payload);
          const credential = credentialRaw as any;

          onReadyToSubmit({
            custom_payload: JSON.stringify({
              id: credential.id,
              rawId: this.bufferEncode(new Uint8Array(credential.rawId)),
              type: credential.type,
              response: {
                authenticatorData: this.bufferEncode(
                    new Uint8Array(credential.response.authenticatorData)
                ),
                clientDataJSON: this.bufferEncode(
                    new Uint8Array(credential.response.clientDataJSON)
                ),
                signature: this.bufferEncode(
                    new Uint8Array(credential.response.signature)
                ),
                userHandle: this.bufferEncode(
                    new Uint8Array(credential.response.userHandle)
                ),
              },
            }),
          });
          submit();
        }
      } catch (e) {
        console.log(e);
        this.error = e;
      }
    },
  },
  created() {
    // if (Array.isArray(this.prepareResponse.available_mfas)) {
    //   this.prepareResponse.available_mfas.map(mfa => {
    //     if (OTP_METHOD.includes(mfa)) {
    //       this.otpTypeItems.push(mfa);
    //     }
    //   })
    // }
  },
});
